import React from "react";

export function PageHeader({ title, subtitle, action, testId = "page-header" }) {
  return (
    <header
      className="px-6 sm:px-10 pt-8 sm:pt-10 pb-6 flex flex-col sm:flex-row sm:items-end justify-between gap-4 animate-fade-in"
      data-testid={testId}
    >
      <div className="min-w-0">
        <h1 className="font-heading text-3xl sm:text-[2.5rem] leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-brand-mediumGrey mt-2 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {action && <div className="shrink-0 flex items-center gap-2">{action}</div>}
    </header>
  );
}

export function PageBody({ children }) {
  return <div className="px-6 sm:px-10 pb-12 animate-fade-in">{children}</div>;
}

export function ComingSoon({ titleKey, phase }) {
  const { useTranslation } = require("react-i18next");
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center px-10">
      <div className="max-w-md w-full bg-white border border-brand-lightGrey rounded-2xl p-10 text-center shadow-sm">
        <img src="/brand/logo-color.png" alt="" style={{ height: 36, width: "auto" }} className="mx-auto mb-6 opacity-80" />
        <h2 className="font-heading text-2xl">{t(titleKey)}</h2>
        <p className="mt-3 text-sm text-brand-mediumGrey">{t("common.comingSoon", { phase })}</p>
      </div>
    </div>
  );
}

/** Default wrapper: title/subtitle header + body. */
export default function PageChrome({ title, subtitle, action, children }) {
  return (
    <>
      <PageHeader title={title} subtitle={subtitle} action={action} />
      <PageBody>{children}</PageBody>
    </>
  );
}
